module.exports = __webpack_public_path__ + "static/media/klepsydra.878b6c0f.svg";